<template>
  <b-modal id="modal-approval" ref="modal" size="lg" title="Work From Home Approval" @show="setData" :hide-footer="hideButton">
    <b-form  >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <legend><em class="fa fa-calendar"></em> Work from Home Request</legend>
              <div class="form-row">
                <label class="col-md-3">Employee</label>
                <div class="col-md-6 mb-3">
                  {{detail.emp_name}}
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Reason</label>
                <div class="col-md-6 mb-3">
                  {{detail.reason}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-6 mb-3">
                  {{detail.status_name}}
                </div>
              </div>
              <hr>
              <legend><em class="fa fa-book"></em> Work from Home - Duty and Project</legend>
              <div class="form-group">
                <div class="table-responsive">
                  <table class="table table-hover table-striped" aria-label="Work from Home">
                    <thead>
                    <tr>
                      <th style="width:50px" id="no">No</th>
                      <th style="width:150px" id="project">Project</th>
                      <th style="width:150px" id="date">Date</th>
                      <th style="width:150px" id="hours">Hours</th>
                      <th style="width:150px" id="notes">Notes</th>
                    </tr>
                    </thead>
                    <tbody id="tickets-body">
                    <tr v-for="(item, i) in items">
                      <td>{{i+1}}</td>
                      <td>{{item.project_name}}</td>
                      <td>{{item.date}}</td>
                      <td>{{item.hours}}</td>
                      <td>{{item.notes}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr/>
              <legend><em class="fa fa-users"></em> Approval Information</legend>
              <list-supervisor-finish :list_supervisor="list_supervisor" v-if="!arr_status.includes(detail.wfh_stat_id)"></list-supervisor-finish>
              <list-supervisor  v-else></list-supervisor>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer >
      <div class="w-100">
        <button class="btn btn-success float-right mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
        <button class="btn btn-danger float-right mr-1" @click="stat_id=5; handleOk($event)"> Reject </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from "bootstrap-vue";
import ListSupervisorFinish from "../employee/ListSupervisorFinish";
import ListSupervisor from "../employee/ListSupervisor";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";

export default {
  name: "WorkFromHomeApproval",
  components:{ListSupervisor, ListSupervisorFinish, BForm, BModal},
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return{
      hideButton:true,
      stat_id:1,
      detail:{},
      items:[],
      arr_status:[0],
      list_supervisor:[]
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        this.getDetail()
      }, 100)
    },
    handleOk(evt){
      evt.preventDefault()
      let payload = {
        stat_id:this.stat_id,
        emp_id:this.$store.getters.empId,
        trans_id:this.data.trans_id,
        master_id:this.data.master_id,
        log_id:this.data.id
      }

      AxiosCall.Post(payload, urlApi.wfh.approval).then(res=>{
        if(res.success){
          this.$root.$children[0].successMessage(res.message)
          this.$refs.modal.hide()
          this.$parent.getData()
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    getDetail(){
      AxiosCall.Get({id:this.data.master_id}, urlApi.wfh.detail).then(res=>{
        if(res.success){
          this.detail.reason = res.atributes.reason
          this.detail.emp_name = res.atributes.emp_name
          this.detail.emp_id = res.atributes.emp_id
          this.detail.wfh_stat_id = res.atributes.wfh_stat_id
          this.detail.status_name = res.atributes.wfh_stat_name
          this.items = res.atributes.items !== null ? JSON.parse(res.atributes.items) : []
          this.hideButton =  (this.detail.emp_id == this.$store.getters.empId) ? true :false
          if(!this.arr_status.includes(res.atributes.wfh_stat_id)) this.getListSupervisor()
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getListSupervisor(){
      let payload = {
        id:this.data.master_id
      }
      AxiosCall.Get(payload, urlApi.wfh.status).then(res=>{
        if(res.success){
          this.list_supervisor = res.atributes
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    }
  }
}
</script>